function ogDisabledIfInvalid() {
  return {
    restrict: 'A',
    scope: {},
    require: '^form',
    link: function(scope, element, attrs, formCtrl) {
      scope.$watch(() => formCtrl.$submitted && formCtrl.$invalid, (disabled) => {
        if (disabled) {
          element.attr('disabled', '');
        }
        else {
          element.removeAttr('disabled');
        }
      });
    }
  };
}

ogDisabledIfInvalid.$inject = [];

module.exports = ogDisabledIfInvalid;
